const roles = { forwarder: 'forwarder', gha: 'gha' };

const roleId = { 
  admin: 1, 
  forwarderAdmin: 2, 
  forwarderUser: 3, 
  ghaAdmin: 4, 
  ghaOffice: 5, 
  ghaWarehouse: 6,
  ghaSupervisor: 7,
  ghaManager: 8,
  ghaAccounting: 9,
  ghaScreener: 10,
  ghaWarehouseScreener: 11,
  ghaDashboard: 12,
  ghaAirlineRepresentative: 13,
  ghaOfflineRFSRep: 14,
  ghaSupervisorWh: 15,
  ghaManagerWh: 16,
  superUser: 17,
  laxOfficeAgent: 18,
  ghaAccReco: 19
};
const titles = { 
  forwarder: 'Forwarder', 
  ghaOffice: 'GHA' , 
  ghaWarehouse: 'GHA Warehouse', 
  fwdAdmin: 'Forwarder Administrator', 
  ghaAdmin: 'GHA Administrator',
  ghaSupervisor: 'GHA Supervisor',
  ghaManager: 'GHA Manager',
  ghaAccounting: 'GHA Accounting',
  ghaScreener: 'GHA Screener',
  ghaWarehouseScreener: 'GHA Warehouse Screener',
  ghaDashboard: 'GHA Dashboard',
  ghaAirlineRepresentative: 'GHA Airline Representative',
  ghaOfflineRFSRep: 'GHA Offline RFS',
  ghaSupervisorWh: 'GHA Supervisor Warehouse',
  ghaManagerWh: 'GHA Manager Warehouse',
  superUser: 'GHA Super User',
  laxOfficeAgent: 'LAX Office Agent',
  ghaAccReco: 'GHA Acc Reco'
};

const forwarderRoles = [
  { code: 'forwarderAdmin', name: 'Forwarder Admin' },
  { code: 'forwarderUser', name: 'Forwarder User' }
];

const ghaRoles = [
  { code: 'ghaAdmin', name: 'GHA Admin' },
  { code: 'ghaOffice', name: 'GHA Office' },
  { code: 'ghaWarehouse', name: 'GHA Warehouse' },
  { code: 'ghaSupervisor', name: 'GHA Supervisor' },
  { code: 'ghaManager', name: 'GHA Manager' },
  { code: 'ghaAccounting', name: ' GHA Accounting' },
  { code: 'ghaScreener', name: 'GHA Screener' },
  { code: 'ghaWarehouseScreener', name: 'GHA WarehouseScreener' },
  { code: 'ghaDashboard', name: 'GHA Dashboard' },
  { code: 'ghaAirlineRepresentative', name: 'GHA Airline Representative' },
  { code: 'ghaOfflineRFSRep', name: 'GHA Offline RFS Rep' },
  { code: 'ghaSupervisorWh', name: 'GHA Supervisor Warehouse' },
  { code: 'ghaManagerWh', name: 'GHA Manager Warehouse' },
  { code: 'laxOfficeAgent', name: 'LAX Office Agent' },
  { code: 'ghaAccReco', name: 'GHA Acc Reco' },
];

function userRoleToString(id) {
  switch(id) {
    case roleId.forwarderAdmin: return 'Forwarder admin';
    case roleId.forwarderUser: return 'Forwarder office';
    case roleId.ghaAdmin: return 'GHA admin';
    case roleId.ghaOffice: return 'GHA office';
    case roleId.ghaWarehouse: return 'GHA warehouse user';
    case roleId.ghaSupervisor: return 'GHA Supervisor user';
    case roleId.ghaManager: return 'GHA Manager user';
    case roleId.ghaAccounting: return 'GHA Accounting user';
    case roleId.ghaScreener: return 'GHA Screener user';
    case roleId.ghaWarehouseScreener: return 'GHA Warehouse Screener user';
    case roleId.ghaDashboard: return 'GHA Dashboard user';
    case roleId.ghaAirlineRepresentative: return 'GHA Airline Representative user';
    case roleId.ghaOfflineRFSRep: return 'GHA Offline RFS Rep';
    case roleId.ghaSupervisorWh: return 'GHA Supervisor Warehouse';
    case roleId.ghaManagerWh: return 'GHA Manager Warehouse';
    case roleId.superUser: return 'GHA Super User';
    case roleId.laxOfficeAgent: return 'LAX Office Agent';
    case roleId.ghaAccReco: return 'GHA Acc Reco';
    default: throw new Error("Invalid user role");
  }
}

export default {
  roles,
  titles,
  roleId,
  userRoleToString: userRoleToString,
  forwarderRoles,
  ghaRoles
}